import React from 'react';
import { debounce } from 'lodash';
import { useSingletonSearchEventIntersectionObserver } from './useSingletonIntersectionObserver';
import { AnalyticsContext } from 'analytics';
import { useSelector } from 'react-redux';
import { allPoisByIdsHeapSelector, PoiHeapDict } from 'store/state/selectors/poisHeap';
import { poiEventPayload } from 'store/sagas/analytics/property';
import { userProfileSelector } from 'store/state/domainData/selectors/currentUser';

const TIME_TO_TRIGGER = 1000;


export function useSearchCardEventIntersection<T extends HTMLElement>(containerRef: React.MutableRefObject<T>, poiId: string) {
  const { sendEvent } = React.useContext(AnalyticsContext);
  const allPois: PoiHeapDict = useSelector(allPoisByIdsHeapSelector);
  const currentUser = useSelector(userProfileSelector);
  const poi: any = allPois[poiId];
  const intersectionHandler = React.useCallback(debounce((e: IntersectionObserverEntry) => {
    if (e.isIntersecting) {
      const poiPayload = poiEventPayload({ poi, estimatedPrice: null, isLeadingAgent: false, currentUser });
      sendEvent('property_marketplace_expose', 'property', { ...poiPayload, forceProperty: true });
    }
  }, TIME_TO_TRIGGER), []);

  useSingletonSearchEventIntersectionObserver(intersectionHandler, containerRef);
}
